import React, { useState } from 'react';
import { Button } from '../Button';
import SEO from '../SEO';
import '../styles/pages.css';

/**
 * SignUp Page - Registration and contact form
 */
export default function SignUp() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    phone: '',
    interest: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          company: '',
          phone: '',
          interest: '',
          message: ''
        });
      }, 3000);
    }, 1500);
  };

  return (
    <main className='signup-page'>
      <SEO
        title='Sign Up'
        description='Get started with IURIX. Tell us about your project and our team will follow up within 24 hours to discuss cloud, AI, DevOps, or security solutions.'
        path='/sign-up'
      />
      <div className='signup-container'>
        <div className='signup-content'>
          <h1>Get Started with IURIX</h1>
          <p>Join hundreds of companies transforming their businesses with our solutions</p>

          {submitted && (
            <div className='success-message glass'>
              <span className='success-icon'>✓</span>
              <h3>Thank You!</h3>
              <p>We'll be in touch shortly with more information</p>
            </div>
          )}

          {!submitted && (
            <form className='signup-form glass-dark' onSubmit={handleSubmit}>
              <div className='form-row'>
                <div className='form-group'>
                  <label htmlFor='firstName'>First Name *</label>
                  <input
                    type='text'
                    id='firstName'
                    name='firstName'
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder='John'
                    required
                  />
                </div>
                <div className='form-group'>
                  <label htmlFor='lastName'>Last Name *</label>
                  <input
                    type='text'
                    id='lastName'
                    name='lastName'
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder='Doe'
                    required
                  />
                </div>
              </div>

              <div className='form-group'>
                <label htmlFor='email'>Email Address *</label>
                <input
                  type='email'
                  id='email'
                  name='email'
                  value={formData.email}
                  onChange={handleChange}
                  placeholder='john@example.com'
                  required
                />
              </div>

              <div className='form-row'>
                <div className='form-group'>
                  <label htmlFor='company'>Company Name</label>
                  <input
                    type='text'
                    id='company'
                    name='company'
                    value={formData.company}
                    onChange={handleChange}
                    placeholder='Your Company'
                  />
                </div>
                <div className='form-group'>
                  <label htmlFor='phone'>Phone Number</label>
                  <input
                    type='tel'
                    id='phone'
                    name='phone'
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder='+1 (555) 000-0000'
                  />
                </div>
              </div>

              <div className='form-group'>
                <label htmlFor='interest'>Area of Interest *</label>
                <select
                  id='interest'
                  name='interest'
                  value={formData.interest}
                  onChange={handleChange}
                  required
                >
                  <option value=''>Select an option</option>
                  <option value='cloud'>Cloud Solutions</option>
                  <option value='ai'>AI & Machine Learning</option>
                  <option value='devops'>DevOps & Automation</option>
                  <option value='security'>Cybersecurity</option>
                  <option value='analytics'>Data Analytics</option>
                  <option value='other'>Other</option>
                </select>
              </div>

              <div className='form-group'>
                <label htmlFor='message'>Message</label>
                <textarea
                  id='message'
                  name='message'
                  value={formData.message}
                  onChange={handleChange}
                  placeholder='Tell us about your project or needs...'
                  rows='5'
                ></textarea>
              </div>

              <Button buttonStyle='btn--primary' buttonSize='btn--large' type='submit' disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </Button>

              <p className='form-note'>We'll respond within 24 hours</p>
            </form>
          )}

          {/* Contact Info */}
          <div className='contact-info'>
            <div className='info-item'>
              <span className='info-icon'>📧</span>
              <div>
                <h4>Email</h4>
                <p>contact@iurix.com</p>
              </div>
            </div>
            <div className='info-item'>
              <span className='info-icon'>📞</span>
              <div>
                <h4>Phone</h4>
                <p>+1 (555) 123-4567</p>
              </div>
            </div>
            <div className='info-item'>
              <span className='info-icon'>📍</span>
              <div>
                <h4>Office</h4>
                <p>San Francisco, CA</p>
              </div>
            </div>
          </div>
        </div>

        {/* Side Visual */}
        <div className='signup-visual'>
          <div className='visual-card card-a'></div>
          <div className='visual-card card-b'></div>
          <div className='visual-card card-c'></div>
        </div>
      </div>
    </main>
  );
}
